 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import LOVE_1 from '@/components/love_1'
 import TITLE from '@/components/title'
 import COPYRIGHT from '@/components/Copyright'
 import CONTENTS from '@/components/Contents'
 import INTRODUCTION from '@/components/Introduction'
 import CHAPTER1 from '@/components/Chapter1'
 import CHAPTER2 from '@/components/Chapter2'
 import CHAPTER3 from '@/components/Chapter3'
 import CHAPTER4 from '@/components/Chapter4'
 import TECHNIQUES from '@/components/Techniques'
 import ABBREVIATIONS from '@/components/Abbreviations'
 import CONTRIBUTORS from '@/components/Contributors'
 import SUPPLIES from '@/components/Supplies'
 import LOVE_2 from '@/components/love_2'
 import ACKNOWLEDGEMENTS from '@/components/acknowledgements'
 import INDEX from '@/components/index'
 import BACKCOVER from '@/components/backcover'
 import ABRAMS_STANDALONEBACKAD from '@/components/Abrams_StandaloneBackad'
 import OR_STANDALONEBACKAD from '@/components/OR_StandaloneBackad'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Contents",
 			"name" : "Contents",
 			"component" : CONTENTS
 		},
 		{
 			"path" : "/Introduction",
 			"name" : "Introduction",
 			"component" : INTRODUCTION
 		},
 		{
 			"path" : "/Chapter1",
 			"name" : "Chapter1",
 			"component" : CHAPTER1
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js